export const MapperTypeImportLevel = {
	order_import: 10
}

export const MapperTypeCompanyLevel = {
	none: 0,
	loading: 1,
	unloading: 2,
	loading_unloading_cc: 3,
	...MapperTypeImportLevel
}

export const MapperType = {
	...MapperTypeCompanyLevel
}
